import { useState } from "react";
import Modal from "../../../utils/components/Modal";
import SelectBox from "../../../utils/components/SelectBox";
import { IoMdClose } from "react-icons/io";

const TaskCancelModal = ({ show, hideModal, cancelAction }) => {
  const [selectedReason, setSelectedReason] = useState([]);
  return (
    <div>
      <Modal
        title="Görev İptal"
        positiveButtonNode="İptal Et"
        negativeButtonNode="Vazgeç"
        positiveButtonHandler={cancelAction}
        modalSize="lg"
        show={show}
        setShow={hideModal}
      >
        <div className="row">
          <div className="col-12">
            <p className="fw-bold fs-6 text-uppercase text-secondary text-end mb-2">
              Görev No: 1202
            </p>
          </div>
          <div className="col-12 mt-2 text-center">
            <p className="text-orange fs-3">HSE-PEN-YCF-0032</p>
            <p className="text-secondary fs-6">Yüksekte Çalışma Formu</p>
          </div>
          <div className="col-12 mt-2 text-center">
            <p className="fw-bold fs-6 text-uppercase text-secondary mt-4 mb-0">
              Görev Atanan
            </p>
            <div className="mt-2">
              {[1, 2, 3, 4, 5].map((item, index) => (
                <span
                  className="badge bg-secondary text-center py-1 px-2 me-3 mb-2"
                  key={index}
                >
                  Ozan Küçük, Penguen
                  <IoMdClose
                    className="fw-bold cursor--pointer fill-white fs-5 ms-2"
                    onClick={() => {
                      console.log("clicked");
                    }}
                  />
                </span>
              ))}
            </div>
          </div>
          <div className="col-12 mt-2 text-center">
            <p className="fw-bold fs-6 text-uppercase text-secondary mt-3 mb-0">
              Bilgi için
            </p>
            <div className="mt-2">
              {[1, 2, 3, 4].map((item, index) => (
                <span
                  className="badge bg-secondary text-center py-1 px-2 me-3 mb-2"
                  key={index}
                >
                  Elif Orman, TAV
                  <IoMdClose
                    className="fw-bold cursor--pointer fill-white fs-5 ms-2"
                    onClick={() => {
                      console.log("clicked");
                    }}
                  />
                </span>
              ))}
            </div>
          </div>
          <div className="col-12 my-5 text-center">
            <p className="fw-bold fs-6 text-uppercase text-secondary mb-0">
              Bitiş Tarihi: 12.12.2020
            </p>
          </div>
          <div className="col-10 ms-5 border border-2 rounded pt-4 pb-2 mb-4">
            <p className="ps-2 text-secondary">Görev İptal edildiğinde:</p>
            {[1, 2, 3, 4].map((item, index) => (
              <p className="ps-4 text-secondary" key={index}>
                -Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>
            ))}
          </div>
          <div className="col-10 my-5 ms-5">
            <SelectBox
              options={[
                { value: "1", label: "Selection 1" },
                { value: "2", label: "Selection 2" },
                { value: "3", label: "Selection 3" },
              ]}
              placeholder="Görev İptal Sebebi"
              value={selectedReason}
              onChange={(selectedReason) => setSelectedReason(selectedReason)}
            ></SelectBox>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TaskCancelModal;
